import React, { useState } from "react";

// const backendURI = '18.219.96.136/API';
const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;

interface GlobalPosition {
  latitude: number;
  longitude: number;
}

interface ExampleData {
  organizationId: string;
  jobsiteId: string;
  sessionId: string;
  vehicleId: string;
  globalPosition: GlobalPosition;
}

const TestMongoDB: React.FC = () => {
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handlePostRequest = async () => {
    // const exampleData: ExampleData = {
    //   organizationId: 'Org001',
    //   jobsiteId: 'JobSite001',
    //   sessionId: 'Session001',
    //   vehicleId: 'Vehicle1',
    //   globalPosition: {
    //     latitude: 14.3616643165,
    //     longitude: -90.70847219414063,
    //   },
    // };
    const exampleData: any = {
      globalPosition: {
        latitude: 14.3616643165,
        longitude: -90.70847219414063,
      },
    };

    try {
      // 'http://localhost:3000//organizations/Org001/jobsites/JobSite001/sessions/Session001/vehicles/Vehicle1/update'
      const res = await fetch(
        "https://" +
          backendURI +
          "/organizations/Org001/jobsites/JobSite001/sessions/Session001/vehicles/Vehicle1/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(exampleData),
        },
      );

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      setResponse(data);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div>
      <h1>Test MongoDB</h1>
      <button onClick={handlePostRequest}>Send POST Request</button>
      {response && (
        <div>
          <h2>Response:</h2>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
      {error && (
        <div>
          <h2>Error:</h2>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default TestMongoDB;
